import unitJobs from "@frog/source/data/units.js"
import games from "@frog/source/data/games/index.js"
import unitsprites from "@frog/source/data/unitsprites.js"
import audiotriggers from "@frog/source/data/audiotriggers.js"

import PaletteSwap from "@frog/source/juice/utility/PaletteSwap.js"

export default new class Preload {
    constructor() {
        this.loadedImageCount = 0
        this.images = {}

        window.frog = window.frog || {}
        window.frog.preload = this

        Object.values(unitsprites).map((unitspritesSection) => {
            Object.values(unitspritesSection).forEach((imageURL) => {
                this.images[imageURL] = {"url": imageURL}
            })
        })

        Object.values(unitJobs).forEach((unit) => {
            if(unit.portraits != undefined) {
                Object.values(unit.portraits).forEach((portrait) => {
                    const imageURL = portrait
                    this.images[imageURL] = {"url": imageURL}
                })
            }
            if(unit.sprites != undefined) {
                Object.values(unit.sprites).forEach((sprite) => {
                    if(sprite.frames instanceof Array) {
                        sprite.frames.forEach((frame) => {
                            const imageURL = frame.image
                            this.images[imageURL] = {
                                "url": imageURL,
                            }
                        })
                    }
                })
            }
        })
        Object.values(games).forEach((game) => {
            Object.values(game.chapters).forEach((chapter) => {
                const imageURL = chapter.stage.image
                this.images[imageURL] = {"url": imageURL}
            })
        })

        Object.values(this.images).forEach((image) => {
            image.element = new Image()
            image.element.src = image.url
            image.element.addEventListener("load", () => {
                image.element.isLoaded = true

                if(image.paletteKeys != undefined) {
                    image.palettes = {}
                    image.paletteKeys.forEach((paletteKey) => {
                        image.palettes[paletteKey] = PaletteSwap(image.element, paletteKey)
                    })
                }

                image.isLoaded = true
                this.loadedImageCount += 1
            })
        })
    }
    get isLoading() {
        if(audiotriggers["Hell:Opening:Music"].readyState < 4) return true
        if(audiotriggers["Hell:Opening:Narration"].readyState < 4) return true
        if(document.fonts.check("12px base") == false) return true
        if(document.fonts.check("12px header") == false) return true
        if((this.loadedImageCount / Object.values(this.images).length) < 1) return true
        return false
    }
}
